module.exports = __webpack_public_path__ + "static/img/you.5c662b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/gongchengshi/you.png
// module id = F+vI
// module chunks = 6